import {Store} from '@aofl/store';
let store = new Store(aofljsConfig.applicationDebug);
export default store;



// WEBPACK FOOTER //
// ./store/index.js